import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ImageService {
  private http = inject(HttpClient);


  getImage(imageUrl: string): Observable<Blob> {

    return this.http
        .get(imageUrl, {responseType: 'blob'} );
  }
}
